// extracted by mini-css-extract-plugin
export var createdDate = "_mw-1";
export var divider = "_mw-2";
export var headerDivider = "_mw-3";
export var messagesCard = "_mw-0";
export var messagesContainer = "_mw-6";
export var messagesContainerWrapper = "_mw-4";
export var showLeftPanelButton = "_mw-8";
export var topButtons = "_mw-7";
export var withPadding = "_mw-5";